module.exports = __webpack_public_path__ + "static/Leif-Nixon.d2aae887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Leif-Nixon.jpg
// module id = 51
// module chunks = 168707334958949